export const contentTableConfig = {
  title: '企微账号交接列表',
  propList: [
    {prop: 'createTime', label: '发起时间', minWidth: '100', sortable: 'custom'},
    {prop: 'finishTime', label: '完成时间', minWidth: '100', slotName: 'finishTime', sortable: 'custom'},
    {prop: 'corpName', label: '主体名称', minWidth: '80', slotName: 'corpName'},
    {prop: 'account', label: '交接企微号', minWidth: '80', slotName: 'account'},
    {prop: 'fromUserName', label: '使用人姓名', minWidth: '80'},
    {prop: 'toUserName', label: '承接人姓名', minWidth: '80'}
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
